export const productsEn = {
    title: 'Products',
    list: 'Product list',
    detail: 'Product detail',
    create: 'Create product',
    delete: 'Delete product',
    deleteConfirm: 'Are you sure you want to delete this product?',
    columns: {
        encoding: 'Encoding',
        id: 'ID',
        productId: 'Product ID',
        name: 'Name',
        rfidChipTemplate: 'RFID chip template',
        endRollLabelTemplate: 'End roll label template',
        actions: 'Actions'
    },
    model: {
        encoding: 'Encoding',
        productId: 'Product ID',
        name: 'Product name',
        rfidChipTemplate: 'RFID chip template',
        endRollLabelTemplate: 'End roll label template',
        noTemplate: 'No template'
    },
    errors: {
        fetchFailed: 'Failed to load products',
        createFailed: 'Failed to create product',
        updateFailed: 'Failed to update product',
        deleteFailed: 'Failed to delete product'
    },
    success: {
        created: 'Product created successfully',
        updated: 'Product updated successfully',
        deleted: 'Product deleted successfully'
    }
}
